import { memo } from 'react'
import { CardMedia, CardHeader, Box, styled } from '@mui/material'

import CardBase from 'features/common/ui/Cards/CardBase/CardBase'
import { Map } from 'features/maps/types'

interface MapSampleCardProps {
  map: Map
  onClick?: () => void
}

const Card = styled(CardBase)(({ theme }) => ({
  position: 'relative',
  '& .MuiCardMedia-root': {
    height: theme.spacing(33)
  },
  '& .MuiCardHeader-root': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    padding: theme.spacing(2, 2.5),
    backgroundImage:
      'linear-gradient(to bottom, rgba(22, 39, 69, 0.32), rgba(22, 39, 69, 0.64) 63%, rgba(22, 39, 69, 0.92))',
    alignItems: 'flex-end'
  }
}))

function MapSampleCard({ map, onClick }: MapSampleCardProps) {
  const { title = '', description = '', thumbnailUrl } = map

  return (
    <Card onClick={onClick}>
      <Box overflow="hidden">
        <CardMedia image={thumbnailUrl} title={title} component="img" />
      </Box>
      <CardHeader
        title={title}
        titleTypographyProps={{
          variant: 'subtitle1',
          color: 'common.white'
        }}
        subheader={description}
        subheaderTypographyProps={{
          variant: 'body2',
          color: 'common.white',
          mt: (theme) => theme.spacing(0.5),
          minHeight: (theme) => theme.spacing(5)
        }}
      />
    </Card>
  )
}

export default memo(MapSampleCard)
